import {
  ChartRow,
  ChartRowElement,
  ChartRowGroup,
  ChartSubsection,
  ChartSubsectionContent,
  ChartSubsectionHeader,
} from "modules/charts-shared";
import { RADIOLOGY_GRID_COLUMNS } from "../radiology-chart/constants";
import { RadiologyInterpretationProps } from "../radiology-chart/types";

function D006Interpretation(props: RadiologyInterpretationProps) {
  const {
    index,
    chartCode,
    encounterId,
    sectionId,
    sectionCode,
    sectionSubCode,
    onRemoveElement,
  } = props;

  const sectionDelimiter = `rad.${index}.${chartCode}${sectionId}${sectionCode}${sectionSubCode}`;

  return (
    <ChartSubsection
      header={
        <ChartSubsectionHeader
          showNotesBtn
          showDeleteBtn
          chartId={chartCode}
          encounterId={encounterId}
          sectionId={sectionCode}
          showInteractions={false}
          subsectionId={`${sectionSubCode}_Q001`}
          subsectionLabel="Hip"
          showAuditsBtn={false}
          onDeleteSubSection={() => onRemoveElement(sectionId)}
        />
      }
      content={
        <ChartSubsectionContent>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement
                label="Hip"
                name={`${sectionDelimiter}Q001A001`}
                type="cross-option"
              />
              <ChartRowElement
                label="L"
                name={`${sectionDelimiter}Q001A002`}
                type="cross-option"
              />
              <ChartRowElement
                label="R"
                name={`${sectionDelimiter}Q001A003`}
                type="cross-option"
              />
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="central"
                name={`${sectionDelimiter}Q001A004`}
                type="cross-option"
              />
              <ChartRowElement
                label="posterior"
                name={`${sectionDelimiter}Q001A005`}
                type="cross-option"
              />
              <ChartRowElement
                label="anterior:"
                name={`${sectionDelimiter}Q001A006`}
                type="cross-option"
              />
              <ChartRowElement
                label="obturator"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A007`}
                type="cross-option"
              />
              <ChartRowElement
                label="pubic"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A008`}
                type="cross-option"
              />
              <ChartRowElement
                label="iliac"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A009`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A010`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                name={`${sectionDelimiter}Q001A011`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
        </ChartSubsectionContent>
      }
    />
  );
}

export { D006Interpretation };
